export const GET_GOODS_RECEIPTS = 'GET_GOODS_RECEIPTS'
export const GET_GOODS_RECEIPT = 'GET_GOODS_RECEIPT'
export const ADD_GOODS_RECEIPTS = 'ADD_GOODS_RECEIPTS'
export const UPDATE_GOODS_RECEIPTS = 'UPDATE_GOODS_RECEIPTS'
export const DELETE_GOODS_RECEIPT_IN_BULK = 'DELETE_GOODS_RECEIPT_IN_BULK'
export const DELETE_GOODS_RECEIPT_BY_ID = 'DELETE_GOODS_RECEIPT_BY_ID'
export const GOODS_RECEIPT_REPORT = 'GOODS_RECEIPT_REPORT'
